module.exports = __webpack_public_path__ + "images/1bc18fd0.www_3_group_kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/groupintro/www_3_group_kor.png
// module id = 620
// module chunks = 0